export const CHART_TYPES = {
	statusCategory: 'STATUS_CATEGORY',
	issueProgress: 'ISSUE_PROGRESS',
	teamProgress: 'TEAM_PROGRESS',
	teamCapacity: 'TEAM_CAPACITY',
	blockers: 'BLOCKERS',
	highestPriority: 'HIGHEST_PRIORITY',
	unassignedIssues: 'UNASSIGNED_ISSUES',
	overlappingBlockers: 'OVERLAPPING_BLOCKERS',
	overdue: 'OVERDUE',
} as const;

export type CHART_TYPES = (typeof CHART_TYPES)[keyof typeof CHART_TYPES];

export const AVAILABLE_CHARTS: (
	| 'STATUS_CATEGORY'
	| 'ISSUE_PROGRESS'
	| 'TEAM_PROGRESS'
	| 'TEAM_CAPACITY'
	| 'BLOCKERS'
	| 'HIGHEST_PRIORITY'
	| 'UNASSIGNED_ISSUES'
	| 'OVERLAPPING_BLOCKERS'
	| 'OVERDUE'
)[] = [
	CHART_TYPES.statusCategory,
	CHART_TYPES.issueProgress,
	CHART_TYPES.teamProgress,
	CHART_TYPES.teamCapacity,
	CHART_TYPES.blockers,
	CHART_TYPES.highestPriority,
	CHART_TYPES.unassignedIssues,
	CHART_TYPES.overlappingBlockers,
	CHART_TYPES.overdue,
];

export const SCHEDULING_MODES = {
	SCRUM: 'Scrum',
	KANBAN: 'Kanban',
} as const;

export const CAPACITY_UNIT = {
	HOURS: 'HOURS',
	POINTS: 'STORY_POINTS',
	DAYS: 'DAYS',
} as const;

export const SPRINT_STATE = {
	CLOSED: 'CLOSED',
	ACTIVE: 'ACTIVE',
	FUTURE: 'FUTURE',
} as const;
